<template>
  <b-form @submit="onSubmit" class="row">
    <b-card class="mt-2">
      <template #header>
        <b-row class="text-end">
          <b-col class="text-start">
            {{ form.id == null ? 'Cadastro' : 'Alteração: ' + form.id }}
            <b-badge variant="success" class="mr-2">{{ labelHeader }}</b-badge>
          </b-col>
          <b-col>
            <b-badge v-if="status ? true : false" class="bg-info text-white">{{
              status
            }}</b-badge>
            <b-button class="ml-2" type="submit" variant="primary">
              Salvar
            </b-button>
            <b-button
              v-if="positionModal == 'center' || positionModal == null"
              class="ml-2"
              variant="light"
              @click="onChangeCloseModal()"
              >X</b-button
            >
          </b-col>
        </b-row>
      </template>
      <div class="row">
        <div v-for="input in fieldsInput" :key="input" :class="input.class">
          <b-form-group v-if="input.type == 'text'" :label="input.label">
            <b-form-input
              v-model="input.value"
              :required="input.required"
              :maxLength="input.maxLength ?? 50"
              :disabled="input.disabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="input.type == 'textarea'" :label="input.label">
            <b-form-textarea
              v-model="input.value"
              rows="2"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group v-if="input.type == 'char'" :label="input.label">
            <b-form-input
              maxlength="1"
              v-model="input.value"
              :required="input.required"
            ></b-form-input>
          </b-form-group>

          <b-form-group v-if="input.type == 'number'" :label="input.label">
            <b-form-input
              type="number"
              v-model="input.value"
              :required="input.required"
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="input.type == 'switch'" :label="input.label">
            <InputSwitch
              v-model="input.value"
              :trueValue="true"
              :falseValue="false"
            />
          </b-form-group>

          <b-form-group v-if="input.type == 'date'" :label="input.label">
            <PrimeCalendar
              v-model="input.value"
              selectionMode="single"
              dateFormat="dd/mm/yy"
              showIcon
            />
          </b-form-group>
          <b-form-group v-if="input.type == 'datetime'" :label="input.label">
            <PrimeCalendar
              v-model="input.value"
              selectionMode="single"
              dateFormat="dd/mm/yy"
              :showTime="true"
              hourFormat="24"
              showIcon
            />
          </b-form-group>
          <b-form-group v-if="input.type == 'money'" :label="input.label">
            <Money3Component
              class="form-control"
              v-bind="config"
              v-model="input.value"
            ></Money3Component>
          </b-form-group>
          <b-form-group
            v-if="input.type == 'moneyDisable'"
            :label="input.label"
          >
            <Money3Component
              class="form-control"
              v-bind="configDisable"
              v-model="input.value"
            ></Money3Component>
          </b-form-group>
          <b-form-group v-if="input.type == 'combo'" :label="input.label">
            <!-- <ComboDefault
              :slug="input.slug"
              :slugId="input.slugId"
              :slugDesc="input.slugDesc"
              :endpoint="input.endpoint"
              :required="input.required"
              @onChangeCombo="
                (value) => {
                  input.value = value
                }
              "
            /> -->
            <SingleSelect
              :slug="input.slug"
              :slugId="input.slugId"
              :slugDesc="input.slugDesc"
              :endpoint="input.endpoint"
              :required="input.required"
              :model="input.value"
              :disabled="input.disabled"
              @onChangeCombo="
                (value) => {
                  input.value = value
                }
              "
            />
          </b-form-group>

          <b-form-group v-if="input.type == 'multiselect'" :label="input.label">
            <VueMultiselect
              mode="tags"
              v-model="input.inputCombo"
              :options="input.optionsCombo"
              noOptionsText="Nenhum resultado encontrado!"
              noResultsText="Nenhum resultado encontrado!"
              placeholder=""
              :searchable="true"
              label="desc"
              trackBy="desc"
              valueProp="id"
              value="id"
              required
            >
            </VueMultiselect>
          </b-form-group>
        </div>
      </div>
    </b-card>
  </b-form>
</template>

<script>
import service from '@/services/BaseService'
import config from '@/functions/formatMoney'
import configDisable from '@/functions/formatMoneyDisable'
import { Money3Component } from 'v-money3'
import moment from 'moment'

export default {
  props: {
    fieldsInput: Array,
    item: Object,
    table: String,
    labelHeader: String,
    positionModal: String,
    status: String,
  },
  components: { Money3Component },
  data() {
    return {
      config: config,
      configDisable: configDisable,
      form: {},
    }
  },
  created() {
    this.initInputs()
  },
  methods: {
    //Inicializa os campos quanto for edição
    initInputs() {
      //Edição
      if (this.item.id) {
        for (let i = 0; i < this.fieldsInput.length; i++) {
          const field = this.fieldsInput[i]
          Object.keys(this.item).map((key) => {
            if (field.slug == key) {
              switch (field.type) {
                case 'number':
                  field.value = Number(this.item[key])
                  break
                case 'money':
                  field.value = this.item[key] ?? 0
                  break
                case 'datetime':
                  field.value = moment(this.item[key]).format(
                    'DD/MM/YYYY - H:mm',
                  )
                  break
                default:
                  field.value = this.item[key]
                  break
              }
            }
          })
        }
      }
      //Cadastro
      else {
        for (let i = 0; i < this.fieldsInput.length; i++) {
          const field = this.fieldsInput[i]
          switch (field.type) {
            case 'money':
              field.value = 0
              break
            default:
              if (field.value == '') {
                field.value = null
              }
              break
          }
        }
      }
    },
    //Monta o json que será enviado na requisição com base nos fields
    setInputs() {
      this.form = {}
      this.fieldsInput.forEach((field) => {
        switch (field.type) {
          case 'date':
            this.form[field.slug] = field.value
              ? moment(field.value).format(
                  field.formatDate ? field.formatDate : 'YYYY-MM-DD H:mm',
                )
              : null
            break
          case 'datetime':
            /*            var format = 'YYYY-M-D HH:mm'
            var timezone = 'America/Sao_Paulo'
            var dateMoment = moment.tz(data, format, timezone) */
            var data = moment(field.value, 'DD/MM/YYYY - H:mm')
            this.form[field.slug] = field.value ? data : null
            break
          default:
            this.form[field.slug] = field.value
            break
        }
      })
    },
    async onSubmit() {
      this.setInputs()
      var http = new service(`default/${this.table}`)
      if (this.item.id == null) {
        await http
          .create(this.form)
          .then((resp) => {
            this.$toast.success('Registro Criado com Sucesso!')
            this.$emit('onChangeForm', resp.data.response)
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message)
          })
      } else {
        await http
          .update(this.item.id, this.form)
          .then(() => {
            this.$toast.success('Registro Atualizado com Sucesso!')
            this.$emit('onChangeForm')
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message)
          })
      }
    },
    onChangeForm() {
      this.$emit('onChangeForm')
    },
    onChangeCloseModal() {
      this.$emit('onChangeCloseModal')
    },
  },
}
</script>
